// extracted by mini-css-extract-plugin
export var desktopWrapper = "Bullets-module--desktopWrapper--cb87f";
export var fadeInAnimation = "Bullets-module--fadeInAnimation--59a15";
export var icon = "Bullets-module--icon--1e4a2";
export var iconWrapper = "Bullets-module--iconWrapper--6c690";
export var icons = "Bullets-module--icons--83ee7";
export var layout = "Bullets-module--layout--08a35";
export var mobileWrapper = "Bullets-module--mobileWrapper--37977";
export var title = "Bullets-module--title--d413f";